'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var baseProgress_module = require('./styles/base-progress.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const baseName = 'progress';
const BaseProgress = ({ id , value , variantName , animated , ariaValueMin =0 , maxValue =100 , ariaValueMax =maxValue , className , label , styleClassLabel , styleClassProgress , ...progressProps })=>{
    const progressBar = React.useRef(null);
    React.useEffect(()=>{
        if (animated) {
            setTimeout(()=>{
                if (progressBar && progressBar.current) {
                    progressBar.current.setAttribute('value', value.toString());
                }
            }, 1000);
        }
    }, [
        value
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React__default.default.createElement(React__default.default.Fragment, null, label && /*#__PURE__*/ React__default.default.createElement("label", {
        className: classnames__default.default(`bf-${baseName}__${variantName}--label`, baseProgress_module['progress-label'], styleClassLabel),
        htmlFor: id
    }, label), /*#__PURE__*/ React__default.default.createElement("div", {
        className: classnames__default.default(className)
    }, /*#__PURE__*/ React__default.default.createElement("progress", _extends({}, progressProps, {
        ref: progressBar,
        "aria-valuemax": ariaValueMax,
        "aria-valuemin": ariaValueMin,
        "aria-valuenow": value,
        className: classnames__default.default(`bf-${baseName}__${variantName}--value`, styleClassProgress),
        id: id,
        max: maxValue,
        value: animated ? 0 : value
    }))));
};

exports.BaseProgress = BaseProgress;
//# sourceMappingURL=base-progress.js.map
